import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import { Col, Row } from 'react-bootstrap';
import Logo from '../../../assets/images/logo.png';
import Lock from '../../../assets/images/lock.png';
import Arrow from '../../../assets/images/backarrow.png';
import Image from 'react-bootstrap/Image';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { useHistory, useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import {
  GetForgetPass,
  selectForgetPass
} from '../../../features/forgetPassword/forgetPassSlice';
import '../login.css';
import swal from 'sweetalert';
import { dev } from '../../../features/network/ApiCall';
function Forgot() {
  let history = useHistory();
  const location: any = useLocation();
  const verifyOtp = useAppSelector(selectForgetPass);
  const dispatch = useAppDispatch();
  const [username, setUserName] = useState<string>();

  useEffect(() => {
    if (location?.state?.id) {
      setUserName(location?.state?.id);
    } else {
      history.push('/RegisteredUser');
    }
  }, [location?.state]);

  const Username = (event: React.ChangeEvent<HTMLInputElement>) =>
    setUserName(event.target.value);
  //const otpDetails = localStorage.getItem("otp");
  // const getOtp: any = otpDetails;
  //const getOtpJson = JSON.parse(getOtp);

  const otpDetails: any = localStorage.getItem('otp');
  // let getOtpJson = JSON.parse(otpDetails);
  // const [isOtp, setIsOtp] = useState(getOtpJson?.otp ? getOtpJson?.otp : undefined);
  let getOtpJson = '';
  const [isOtp, setIsOtp] = useState('');
  const onSubmits = async (event: any) => {
    event.preventDefault();
    let data = {
      emailId: username
    };
    var axios = require('axios');
    var config = {
      method: 'post',
      url: `${dev}/forgot/step1`,
      headers: {
        'Content-Type': 'application/json'
      },
      data: data
    };

    axios(config)
      .then(function (response: any) {
        // console.log(JSON.stringify(response.data));
        // localStorage.setItem("otp", JSON.stringify(response.data.otp));
        if (response.status == 200) {
          // console.log("check password ------->", response.data);
          history.push({
            pathname: `/setpassword`,
            state: {
              id: username
            }
          });
        }
      })
      .catch(function (error: any) {
        if (error.response.status == 404) {
          swal('OTP limit exceeded. Please try after some time.', '', 'error');
        } else {
          swal('Something went wrong!', '', 'error');
        }
        swal(error?.response?.data, '', 'error');
      });
    // await dispatch(GetForgetPass(data));

    // if(isOtp) {
    //   history.push(`/verifyotp/`);
    // }else{
    //  // alert('Opps Somthing went wrong !')
    //   swal("Something went wrong!",  "error");

    // }
  };

  return (
    <>
      <Container fluid style={{ height: 'auto' }}>
        <Row sm={3}>
          <Col></Col>
          <Col
            className='bg-white tb-mar-mob0-desk48 mx-auto loginshadow'
            xxl={3}
            xs={10}
          >
            <div className='my-5 lr-mar-mob4-desk24'>
              <Image
                className='mx-auto d-block'
                style={styles.limg}
                src={Logo}
              />
              <div className='mt-2 mb-3' style={styles.head}>
                Ethics and governance portal
              </div>
              <Image
                className='mx-auto d-block mt-4 mb-2'
                style={styles.img2}
                src={Lock}
              />
              <Row>
                <div className='pt-1' style={styles.text1}>
                  FORGOT PASSWORD
                </div>
              </Row>
              <div className='mt-2 mb-3' style={styles.text2}>
                Reset link will be sent to your registered email
              </div>

              <Form onSubmit={onSubmits}>
                <Form.Group className='mb-3'>
                  <Form.Control
                    className='shadow-none'
                    style={styles.text3}
                    type='text'
                    id='email'
                    name={username}
                    value={username}
                    onChange={Username}
                    placeholder='Email'
                    required
                  />
                </Form.Group>
                <Button
                  // href="/forgotsuccess"
                  style={styles.btn1}
                  variant='danger'
                  type='submit'
                >
                  <label className='pt-2'>SEND</label>
                </Button>
              </Form>
              <br />
              <Row className='justify-content-md-center'>
                <a href='/login' className='mb-5' style={styles.text4}>
                  <Image style={styles.img1} src={Arrow} />
                  BACK TO SIGN IN
                </a>
              </Row>
            </div>
          </Col>
          <Col></Col>
        </Row>
      </Container>
    </>
  );
}

const styles: any = {
  head: {
    fontFamily: 'Georama-Regular',
    fontSize: '18px',
    fontWeight: '500',
    textAlign: 'center'
  },
  limg: {
    width: '159px',
    height: '22px'
  },
  img1: {
    width: '24px',
    height: '24px'
  },
  img2: {
    width: '56px',
    height: '56px'
  },
  text1: {
    textAlign: 'center',
    fontFamily: 'Saira',
    fontSize: '16px',
    fontWeight: '600',
    color: 'black',
    textDecoration: 'none'
  },
  text2: {
    textAlign: 'center',
    fontFamily: 'Saira',
    fontSize: '12px',
    fontWeight: '500',
    color: '#6d6e71'
  },
  text3: {
    fontFamily: 'Saira',
    fontSize: '16px',
    borderRadius: '0px',
    border: 'solid 1px #e4e4e4'
  },
  text4: {
    textAlign: 'center',
    fontFamily: 'Saira',
    fontSize: '12px',
    fontWeight: '600',
    color: 'red',
    textDecoration: 'none'
  },
  btn1: {
    width: '100%',
    height: '48px',
    fontFamily: 'Saira',
    fontSize: '12px',
    fontWeight: '600',
    color: 'white',
    borderRadius: '0px',
    textAlign: 'center'
  }
};

export default Forgot;
